import { Suspense } from "react";

import { LoadingSpinner } from "@/components/LoadingIndicator";
import ModuleMaintenanceDataLoader from "@/sheets/data-loaders/module-maintenance.data-loader";
import ModuleMaintenancePage from "@/sheets/module-maintenance/module-maintenance.page";
import ModuleMaintenanceValidator from "@/sheets/data-loaders/module-maintenance.validator";
import tw from "twin.macro";
import { useTranslation } from "react-i18next";

type ModuleAccessSheetBodyProps = {
  areaId: string;
  moduleAddress: string;
};

const ModuleAccessSheetBody = ({
  areaId,
  moduleAddress,
}: ModuleAccessSheetBodyProps) => {
  const { t: translator } = useTranslation();
  return (
    <div tw="px-2 pb-6">
      <Suspense
        fallback={
          <div tw="flex flex-col justify-center items-center gap-4 py-16">
            <LoadingSpinner css={[tw`text-primary-800 size-10`]} />
            <p tw="text-sm text-primary-800 font-medium">
              {translator("loadingModuleData.title")}
            </p>
          </div>
        }
      >
        <ModuleMaintenanceDataLoader
          areaId={areaId}
          moduleAddress={moduleAddress}
        >
          <ModuleMaintenanceValidator moduleAddress={moduleAddress}>
            <ModuleMaintenancePage />
          </ModuleMaintenanceValidator>
        </ModuleMaintenanceDataLoader>
      </Suspense>
    </div>
  );
};

export default ModuleAccessSheetBody;
